export const REFERRAL_STORAGE_KEY = "ouro_referral_code";
export const REFERRAL_CODE_PATTERN = /^OURO-[A-Z0-9]{4,}$/i;

export function normalizeReferralCode(referralCode) {
  if (typeof referralCode !== "string") return "";

  const normalizedCode = referralCode.trim().toUpperCase();
  return REFERRAL_CODE_PATTERN.test(normalizedCode) ? normalizedCode : "";
}

export function buildReferralInvitePath(referralCode) {
  const normalizedCode = normalizeReferralCode(referralCode);
  return normalizedCode ? `/account?ref=${normalizedCode}` : "/account";
}

export function buildReferralInviteLink(
  referralCode,
  origin = typeof window !== "undefined" ? window.location.origin : ""
) {
  const invitePath = buildReferralInvitePath(referralCode);
  return origin ? `${origin}${invitePath}` : invitePath;
}
